export default "__VITE_ASSET__CyOsQapU__"